module.exports = __webpack_public_path__ + "static/media/BadgePP.60a077a4.svg";